/** @jsxImportSource @emotion/react */
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  css,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import CheckBoxIcon from '@/shared/assets/icons/checkbox.svg?react';
import { FC, memo } from 'react';
import { DATA_TEST_ID_INHERITED } from 'ui-kit/lib/constants/DATA_TEST_ID_INHERITED';
import { inheritDataTestId } from 'ui-kit/lib/utils/dataTestId';

export const Checkbox: FC<MuiCheckboxProps> = ({
  disabled: _,
  checked,
  onChange,
  ...restProps
}) => {
  return (
    <MuiCheckbox
      color="secondary"
      sx={(_theme) => ({
        padding: '12px',
        marginRight: '8px',
        width: 42,
        height: 42,
      })}
      icon={
        <CheckBoxIcon
          data-test-id={inheritDataTestId(restProps, 'checkbox_icon')}
        />
      }
      checked={checked ?? undefined}
      onChange={onChange}
      data-test-id={DATA_TEST_ID_INHERITED}
      {...restProps}
    />
  );
};

interface Props extends Omit<FormControlLabelProps, 'control' | 'onChange'> {
  value?: boolean | undefined | null;
  onChange?: MuiCheckboxProps['onChange'];
  noMargin?: boolean;
  name?: string;
}
export const CheckboxControl = memo(
  ({ value, onChange, noMargin, name = 'checkbox', ...restProps }: Props) => {
    return (
      <FormControlLabel
        name={name}
        css={css`
          margin-left: -5px;
        `}
        data-test-id={DATA_TEST_ID_INHERITED}
        {...restProps}
        control={
          <MuiCheckbox
            color="secondary"
            sx={(t) => ({
              padding: '12px',
              marginRight: noMargin ? 0 : '8px',
              '&.Mui-disabled': { rect: { fill: t.palette.grey[300] } },
            })}
            checked={value ?? undefined}
            onChange={onChange}
            icon={
              <CheckBoxIcon
                data-test-id={inheritDataTestId(restProps, 'checkbox_icon')}
              />
            }
            data-test-id={DATA_TEST_ID_INHERITED}
          />
        }
      />
    );
  }
);

CheckboxControl.displayName = 'CheckboxControl';
